import { useEffect, useState } from 'react'
import {
  ATTRIBUTION_FIELD_KEYS,
  captureAttribution,
  getAttributionFields,
} from '@/lib/attribution'

export default function AttributionHiddenFields() {
  const [fields, setFields] = useState({})

  useEffect(() => {
    captureAttribution()
    setFields(getAttributionFields())
  }, [])

  const names = ATTRIBUTION_FIELD_KEYS.slice()
  Object.keys(fields).forEach((key) => {
    if (names.indexOf(key) === -1) names.push(key)
  })

  return names.map((name) => (
    <input key={name} type="hidden" name={name} value={fields[name] || ''} readOnly />
  ))
}
